import React from 'react';
import s from './style.module.scss';
import { Icon } from '@/design-system/icon/icon';
import { CircleLoader } from '@/design-system/loaders/circle-loader';
import { useUIStore } from '@/stores/ui.store';
import { ClevertapButtonEventPayloadType } from '@/data/types/cms.types';
import { useClevertap } from '@/contexts/analytics/analytics.context';

interface PrimaryButtonProps {
  id: string;
  text: string;
  className?: string;
  prefixIcon?: string;
  suffixIcon?: string;
  onClick?: () => void;
  size?: 'small' | 'large';
  width?: 'full' | 'fit'; //By default is full
  variant?: 'red' | 'midnight' | 'tang-blue' | 'white';
  clevertapEventName?: string;
  clevertapEventPayload?: ClevertapButtonEventPayloadType;
  disabled?: boolean;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  id,
  text,
  className,
  prefixIcon,
  suffixIcon,
  onClick,
  size,
  width,
  variant,
  clevertapEventName,
  clevertapEventPayload,
  disabled,
}) => {
  const clevertap = useClevertap();
  const uiState = useUIStore((state) => state.uiState?.[id]);
  const isDisabled = uiState?.isDisabled ?? disabled ?? false;
  const isLoading = uiState?.isLoading ?? false;
  return (
    <button
      className={`${s.button} ${className ?? ''} ${size ? s[size] : ''} ${
        variant ? s[variant] : ''
      } ${width ? s[width] : ''} `}
      disabled={isDisabled}
      onClick={
        isLoading
          ? undefined
          : () => {
              onClick?.();
              if (clevertapEventName) {
                clevertap?.sendButtonEvent(
                  clevertapEventName,
                  clevertapEventPayload
                );
              }
            }
      }
    >
      {isLoading ? (
        <div className={`${s.loaderCon}`}>
          <CircleLoader size={size === 'small' ? 16 : 24} />
        </div>
      ) : (
        <>
          {prefixIcon && <Icon icon={prefixIcon} className={s.prefixIcon} />}
          <span className={s.text}>{text}</span>
          {suffixIcon && <Icon icon={suffixIcon} className={s.suffixIcon} />}
        </>
      )}
    </button>
  );
};
